module.exports = __webpack_public_path__ + "static/media/marker_bus_stop_selected.6dd36ed1.svg";